import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

import { UtilModule } from '../util/util.module';
import { LayoutSharedModule } from '@aptitude/shared';
import { AngularPipesModule } from '@aptitude/angular-pipes';
@NgModule({
  declarations: [],
  imports: [
    NgbModule,
    CommonModule,
    UtilModule,
    RouterModule,
    FormsModule,
    LayoutSharedModule,
    AngularPipesModule,
  ],
  exports: [LayoutSharedModule],
  providers: [DecimalPipe],
})
export class LayoutModule { }
